import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import theme from 'Theme';
import TopFlair from './top-flair';
import TopMain from './top-main';
import MainTable from './main-table';
import Footer from './HomeComponents/footer';


export default function Home() {
    return (
        <ThemeProvider theme={theme}>
            <Grid
                container
                direction="column"
                alignItems="center"
                style={{ flexWrap: "nowrap" }}
            >
                <TopFlair />
                <TopMain />
                <MainTable />
                <Footer />
            </Grid>
        </ThemeProvider>
    )
}